import React, { ReactNode } from 'react'

import { StoreContext } from 'storeon/react'

import Shared from 'Services/Shared'
import { store } from 'Services/Store'

export function StoreProvider({ children }: { children: ReactNode }) {
  Shared.setStore(store)

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}
